/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import { http } from './utils';

export default {
  list(filters) {
    return http.get('feedback', { params: filters });
  },
  listGroup(groupId) {
    return http.get(`groups/${groupId}/feedback`);
  },
  post(data) {
    return http.post('feedback', data);
  },
  del(feedbackId) {
    return http.delete(`feedback/${feedbackId}`);
  },
  put(feedbackId, data) {
    return http.put(`feedback/${feedbackId}`, data);
  }
};
